

import CTable from './Table/CTable'
import Service from "src/api/Service";

import React, { useEffect, useRef } from "react"
import $ from 'jquery'
 
export default function Table(props) {
 
const [isLoading, setisLoading] = React.useState(true);
const [dataSet, setDataSet] = React.useState([]);


  function getData(){
	var url = "/alert_dashboard/table/"+props.prams.keyname;
	Service.get(url,(status,data)=>{
	if(status==200){
		setDataSet(data);
		setisLoading(false)

   }	

  });
 
  }
useEffect(() => {
	getData();
},[])

if(isLoading){
	return(<>....</>)
}

    return (
            <>
		    <div className='row'>
                <div className='col-lg-7'>
                 <div className='componentNameC'>{props.prams.component}</div>
                 </div>
                    <div className='col-lg-5'>
                    <div className="form-check component_legend" >
                    <span className="bigcheck">
                       
                    </span>
                </div>
                </div>
            </div>

          <CTable data={dataSet} props={props}/>

		</>
         
    )
}

